// wi_6b5960f9-952c-48fc-ab25-68e9f9e5b2da: follow and first-person camera poses. No three.js here.
import { eyePosition, aimDirection } from './scene3d';

export const CAMERAS = ['free', 'follow', 'pov'];
// three.js takes a vertical FOV and CS2's are horizontal at 4:3, so each is converted:
// 90 unscoped, then the zoom levels 40 and 15.
const verticalFov = (horizontal) => (
  Math.round(((2 * Math.atan(0.75 * Math.tan((horizontal * Math.PI) / 360)) * 180) / Math.PI) * 100) / 100
);
export const POV_FOV = verticalFov(90);
export const ZOOM_FOV = { 1: verticalFov(40), 2: verticalFov(15) };
const FOLLOW_BACK = 120;
const FOLLOW_UP = 40;

// Eye at z + 64 - 18 * duckAmount, looking along yaw viewX and pitch viewY.
export function povPose(player) {
  return { position: eyePosition(player), forward: aimDirection(player) };
}

// 120 units behind along the yaw and 40 above, looking at the eye.
export function followPose(player) {
  const eye = eyePosition(player);
  const yaw = ((player.viewX || 0) * Math.PI) / 180;
  return {
    position: {
      x: eye.x - Math.cos(yaw) * FOLLOW_BACK,
      y: eye.y - Math.sin(yaw) * FOLLOW_BACK,
      z: eye.z + FOLLOW_UP,
    },
    target: eye,
  };
}
